import { Navigate, Outlet } from "react-router-dom";
import { EnumModulo, EnumPerfil } from "../../../Utils/Enumeradores/ComunEnum";
import useLogin from "../Hooks/useLogin";

export default function PrivateRouteModulo({ children, id }) {
  const { usuario } = useLogin();

  const modulos = usuario ? (usuario.listaModuloAcceso ? usuario.listaModuloAcceso : []) : [];
  const tieneModulo = modulos.some(x => x.moduloId === id);
  const accesoConfiguracionInspector =
    id === EnumModulo.Configuracion &&
    usuario?.perfilContexto?.id === EnumPerfil.InspectorFiscal;

  if (tieneModulo || accesoConfiguracionInspector) {
    return children ? children : <Outlet />;
  } else {
    return <Navigate to="/" replace />
  }
}
